import React, { useState } from "react";
import SimpleBarReact from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import InputField from "../../../component/input-field";
import AssetList from "./AssetList";
import Pageinfo from "../../../component/Alert/Pageinfo";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  Checkbox,
  DateTime,
  Dropdown,
  Link,
  NumberField,
  Paragraph,
  RadioButton,
  TextField,
  Toggle,
} from "./CustomizedComponent";
import CustomeModal from "../../../component/modal-popup/customeModal";
import swal from "@sweetalert/with-react";
import { deleteAssetEntryPerformance } from "../../../redux/actions/performance";
import {
  getAllActivities,
  getAssetList,
  assetEntryPerformance,
  createTodoPerformance,
  updateTodoPerformance,
  deleteTodoPerformance,
  deleteUploadedFile,
  getTodoPerformance,
  getPerformanceSignedUrl,
  sendTodoReminder,
} from "../../../redux/actions/todoPerformance";
import {
  GET_ALL_ASSET_DATA,
  GET_ALL_FILE_NAME,
  GET_ALL_TODO_PERFORMANCE,
  GET_ALL_TODO_PERFORMANCE_GROUP,
  PERFORMANCE_LOADER,
  SET_ASSET_TYPES,
} from "../../../redux/constants";
import Sharemodal from "./Sharemodal";
import Loader from "../../booking/Loader";
import ExtendActivityModal from "../../../component/home/ExtendActivityModal";
import TransferActivityModal from "../../../component/home/TransferActivityModal";
import PerformanceDateTime from "../Component/PerformanceDateTime";
import {
  getUserById,
  getUserDataByEmailAndCompanyId,
} from "../../../redux/actions/user";
import { decryptData, encryptData, sanitizeInput } from "../../../utils";
import Image from "../../../assets/img/ShiproneLogo.png";
import { getBannerMessage, getMessage } from "../helper";

function ToDoPerformTab({
  activity_assignment_id,
  validation,
  setValidation,
  assetentryvalue,
  setAssetEntryValue,
  activeentry,
  setActiveEntry,
  performancetab,
  setPerformanceTab,
  allowbasedon,
  setAllowBasedon,
  embedded,
  setTab,
}) {
  const [showAlert, setShowAlert] = useState(false);
  const [addPerformanceTab, setaddPerformanceTab] = useState([
    { date: new Date() },
  ]);
  const [openShareModal, setOpenShareModal] = useState(false);
  const {
    assetdata,
    assetlist,
    tododata,
    todocomponentdata,
    todoperformance,
    filename,
    activities,
    tempdata,
    performancegroup,
    performancedata,
    performanceLoader,
    performanceInventoryData,
  } = useSelector((state) => state.todoPerformance);
  const { embeddedUserData } = useSelector((state) => state.user);
  const userData = useSelector((state) => state.auth);

  const { type, email, company, id, name, user_departments, collaborator_ids } = useSelector(
    (state) => state.auth
  );
  // const user_id = embedded
  //   ? embeddedUserData !== ""
  //     ? embeddedUserData.user_ids[0]
  //     : null
  //   : id;
  // const department_id = embedded
  //   ? embeddedUserData !== ""
  //     ? embeddedUserData?.department_ids
  //     : []
  //   : user_departments;

  const user_id = id;
  const department_id = user_departments;
  
  const dispatch = useDispatch();
  const [customFieldMaxRowSize, setCustomFieldMaxRowSize] = useState();
  const [todojson, setTodoJson] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [performdate, setPerformDate] = useState("");
  const [loader, setLoader] = useState(false);
  // const [fileNames, setFileNames] = useState([]);
  const [message, setMessage] = useState("");
  const [allowupdate, setAllowUpdate] = useState(true);
  const [userallow, setUserAllow] = useState(false);
  const [isextend, setIsExtend] = useState(false);
  const [istransfer, setIsTransfer] = useState(false);
  const [showmsg, setShowMsg] = useState(false);
  const [performance, setPerformance] = useState(false);
  const [fileupload, setFileUpload] = useState([]);
  // const [submittodotype, setSubmitTodoType] = useState("");
  const [mandatory_extension, setMandatory_Extension] = useState(false);
  const [inventoryPayload, setInventoryPayload] = useState([]);
  const [isInventoryPayloadChange, setIsInventoryPayloadChange] =
    useState(false);

  // console.log("tododata ==>", tododata);

  const handleAssetText = (item, value) => {
    const index = assetdata.findIndex((ele) => ele.id === item.id);
    if (index !== -1) {
      const copyassetdata = [...assetdata];
      copyassetdata[index].asset_name = value;
      dispatch({ type: GET_ALL_ASSET_DATA, payload: copyassetdata });
    }
  };

  useEffect(() => {
    if (performanceInventoryData) {
      setInventoryPayload(
        performanceInventoryData.inventory.map((inventoryItem) => {
          const obj = {
            actual_qty: inventoryItem.actual_qty,
            actual_date: inventoryItem.actual_date ? inventoryItem.actual_date : inventoryItem.saved_date,
          };
          if (inventoryItem?.sku_master_id) {
            obj.sku_master_id = inventoryItem.sku_master_id;
            obj.purchase_order_sku_id = inventoryItem.purchase_order_sku_id;
          } else {
            obj.product_master_id = inventoryItem.product_master_id;
            obj.sales_order_product_id = inventoryItem.sales_order_product_id;
          }
          return obj;
        })
      );
    }
  }, [performanceInventoryData]);

  const handleInventoryChange = (value, key, index) => {
    setInventoryPayload((prev) => {
      return prev.map((ele, i) => {
        if (i === index) {
          ele[key] = value;
        }
        return ele;
      });
    });
  };

  useEffect(() => {
    if (embedded) {
      dispatch(getUserDataByEmailAndCompanyId());
    }
  }, []);

  useEffect(() => {
    if (todoperformance.length === 0) {
      handleNewPerformance();
    }
  }, [todoperformance, todocomponentdata]);

  useEffect(() => {
    if (Object.keys(tododata).length > 0) {
      const arr = [];
      const check = ["toggle", "radio group", "check box"];
      const status = getPerformActivity(
        tododata,
        type,
        email,
        user_id,
        department_id,
        collaborator_ids
      );

      if (!status) {
        setUserAllow(!status);
        setAllowUpdate(!status);
      } else {
        const checkCondition =
          tododata?.activity.mandatory_extension_request &&
          tododata?.status === "overdue";
        setMandatory_Extension(checkCondition);
        if (tododata?.activity.based_on === "Container") {
          setAllowUpdate(
            (todoperformance.length > 0 &&
              todoperformance.filter(
                (ele) =>
                  ele.value === assetentryvalue[0].based_on &&
                  ele.type !== "save"
              ).length !== 0) ||
              !tododata.can_perform ||
              checkCondition
          );
        } else if (!allowbasedon) {
          setAllowUpdate(
            (todoperformance.length > 0 &&
              todoperformance[0].type !== "save") ||
              !tododata.can_perform ||
              checkCondition
          );
        }
        setUserAllow(false);
      }
      if (
        tododata?.status === "completed" ||
        tododata?.status === "completed with delay"
      )
      setShowAlert(true);
      setMessage("");
      setShowMsg(false);
      if (todoperformance.length > 0) {
        todoperformance.forEach(
          (item) => {
            if (
              (item.value === assetentryvalue[0].based_on &&
                tododata.activity.based_on === "Container") ||
              tododata.activity.based_on === "Document"
            ) {
              item.todo_custom_controls.forEach((ele) => {
                arr.push({
                  activity_performance_control_id:
                    ele.activity_performance_control_id,
                  custom_field_id: ele.custom_field_id,
                  label: ele.label,
                  value:
                    typeof ele.value !== "boolean"
                      ? ele.value
                      : JSON.stringify(ele.value),
                  required: ele.is_required,
                  type: ele.type,
                });
              });
              //debugger;
              setRemarks(item.remarks);
              //debugger;
              if (item.type === "complete") {
                setPerformDate(item.date);
              } else {
                setPerformDate(moment().format("YYYY-MM-DD HH:mm"));
              }
              handleFileUpload(item.files);

              if (assetentryvalue[0].based_on !== item.value && !allowbasedon) {
                setAssetEntryValue([{ based_on: item.value }]);
              }
              if (tododata.activity.based_on === "Document") {
                if (assetentryvalue[0].based_on === item.value)
                  setTodoJson(arr);
              } else setTodoJson(arr);
            }
          }
          // });
        );
      }
      // else {

      //   console.log("This is running everytime.")

      //   if(tododata?.activity.based_on !== "Container") {
      //     setAssetEntryValue([{ based_on: "" }]);
      //   }
      // }
    }
  }, [tododata, assetentryvalue, todoperformance]);

  useEffect(() => {
    let length = tododata?.todo_performance_groups?.length;
    if (length > 0) {
      const name = [];
      tododata.todo_performance_groups.forEach((ele) => {
        name.push({ date: ele.createdAt, type: ele.type });
      });
      setaddPerformanceTab(name);
    } else {
      setaddPerformanceTab([{ date: new Date() }]);
    }
  }, [tododata]);

  useEffect(() => {
    if (todocomponentdata?.length !== 0) {
      todocomponentdata?.sort(function (a, b) {
        return a.sequence - b.sequence;
      });
    }
  }, [todocomponentdata]);

  const handleChange = (e, id, type) => {
    if (type === "dropdown") {
      var value = e === null ? null : e.value;
    } else if (type === "checkbox") {
      var value = JSON.stringify(e.target.checked);
    } else {
      var value = type === "datetime" ? e[0] : sanitizeInput(e.target.value);
    }
    todojson.forEach((ele, index) => {
      if (ele.custom_field_id === id) {
        let copyjson = [...todojson];
        copyjson[index].value = value;
        setTodoJson(copyjson);
      }
    });
  };

  const renderInput = (input, index, validation) => {
    var value = null;

    if (todojson.length > 0) {
      todojson.forEach((ele) => {
        if (ele.custom_field_id === input.activity_custom_field_id) {
          value = ele.value;
        }
      });
    } else if (todoperformance?.length > 0) {
      todoperformance.forEach((item) => {
        item.todo_custom_controls.forEach((ele) => {
          if (ele.custom_field_id === input.activity_custom_field_id)
            value = ele.value;
        });
      });
    }
    const gridPosition = JSON.parse(input.grid_position);
    const inputWidth = gridPosition?.w ? gridPosition.w : 2;
    const gridWidthClass = `${
      parseInt(inputWidth) !== 4 ? (parseInt(inputWidth) / 4) * 100 : 100
    }`;
    const props = {
      index,
      input,
      value,
      allowupdate,
      validation,
      handleChange: handleChange,
      gridWidthClass,
    };
    if (input.todo_component?.type === "text") {
      return <TextField {...props} />;
    } else if (input.todo_component?.type === "toggle") {
      return <Toggle {...props} />;
    } else if (input.todo_component?.type === "radio group") {
      return <RadioButton {...props} />;
    } else if (input.todo_component?.type === "link") {
      return <Link {...props} />;
    } else if (input.todo_component?.type === "check box") {
      return <Checkbox {...props} />;
    } else if (input.todo_component?.type === "dropdown") {
      return <Dropdown {...props} />;
    } else if (input.todo_component?.type === "date/time") {
      return <DateTime {...props} />;
    } else if (input.todo_component?.type === "paragraph") {
      return <Paragraph {...props} />;
    } else if (input.todo_component?.type === "number") {
      return <NumberField {...props} />;
    } else {
      return null;
    }
  };

  const getPerformActivity = (todoinfo, type, email, id, user_departments, collaborator_ids) => {
    if (todoinfo) {
      if(todoinfo.status === "tentative"){
        return false;
      }
      if (todoinfo.activity?.is_immutable) {
        return false;
      }
      if (type === "super-admin" || type === "admin") {
        return true;
      }
      if (todoinfo.user?.id === id) {
        return true;
      } else if (collaborator_ids?.includes(todoinfo?.collaborator_id)) {
        return true;
      } else if (
        todoinfo.department?.id &&
        todoinfo.user === null &&
        user_departments
      ) {
        const result = user_departments.find(
          (item) => item.department_id === todoinfo.department?.id
        );
        return result ? true : false;
      }
      if (todoinfo.user?.email) {
        return todoinfo.user.email.toLowerCase() === email.toLowerCase()
          ? true
          : false;
      }
    }
  };

  useEffect(() => {
    if (todocomponentdata?.length > 0) {
      const lastCustomField = JSON.parse(
        todocomponentdata[todocomponentdata.length - 1].grid_position
      );
      const highestRow = lastCustomField.y;
      setCustomFieldMaxRowSize(highestRow);
    }
  }, [todocomponentdata]);

  const handleAsset = async () => {
    const check = assetdata.find((item) => item.asset_name !== "");
    if (typeof check === "undefined") {
      return swal({
        content: (
          <CustomeModal
            type="warning"
            title="Warning!"
            content={`Please provide atleast one asset name for asset type to submit details.`}
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
    }
    const payload = [];
    assetdata.forEach((item) => {
      if (item.asset_name !== "") {
        item.asset_name = item.asset_name.trim();
        payload.push(item);
      }
    });

    const request = {
      onSuccess: (res) => {
        if (res.status) {
          dispatch(getAllActivities(activity_assignment_id, (resp) => {}));
          swal({
            content: (
              <CustomeModal
                type="success"
                title="Success!"
                content={`Asset entry successfully updated.`}
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        }
      },
      onError: (error) => {
        setLoader(false);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    const handleFlag = (bool) => {
      let data = {
        asset: payload,
        flag: bool,
        activity_assignment_id: activity_assignment_id,
      };
      dispatch(assetEntryPerformance(data, request));
    };
    if (tempdata.length !== 0) {
      swal({
        content: (
          <CustomeModal
            type="confirm"
            title="Do you want to update the status of asset?"
            onClick={() => {
              handleFlag(true);
            }}
            onCancel={() => {
              handleFlag(false);
            }}
            buttonText="Yes"
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
    } else {
      handleFlag(false);
    }
  };

  const handleDeleteAssetEntry = async (asset_entry_id) => {
    setLoader(true);
    const request = {
      onSuccess: (res) => {
        if (res.status) {
          dispatch(getAllActivities(activity_assignment_id, (resp) => {}));
        }
        setLoader(false);
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content={`Asset entry successfully deleted.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
      onError: (error) => {
        setLoader(false);
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(deleteAssetEntryPerformance(asset_entry_id, request));
  };

  const createPayload = (json, status, buttonType) => {
    let formdata = new FormData();
    let payload = {
      company_id: performancedata.company_id,
    };
    // const date = moment(performdate).utc().format("YYYY-MM-DD HH:mm");
    // const date = moment(performdate).format("YYYY-MM-DD HH:mm");
    const date = new Date(performdate);
    // console.log("performdate", date);

    if (process.env.REACT_APP_ENCRYPTION === "true") {
      payload["activity_id"] = tododata.activity.activity_id;
      payload["activity_assignment_id"] = activity_assignment_id;
      payload["activity_assignment_mapping_id"] =
        tododata.activity_assignment_mapping_id;
      payload["date"] = date;
      payload["status"] = status;
      payload["remarks"] = remarks;
      payload["custom_fields"] = JSON.stringify(json);
      payload["type"] = buttonType;
      payload["file_upload_data"] = JSON.stringify(fileupload);
      if (isInventoryPayloadChange) {
        payload["inventory_data"] = JSON.stringify(inventoryPayload);
      }
      if (
        tododata.todo_performance_groups[performancetab - 1]
          ?.todo_performance_group_id
      ) {
        payload["todo_performance_group_id"] =
          tododata.todo_performance_groups[
            performancetab - 1
          ].todo_performance_group_id;
      }
    } else {
      formdata.append("company_id", performancedata.company_id);
      formdata.append("activity_id", tododata.activity.activity_id);
      formdata.append("activity_assignment_id", activity_assignment_id);
      formdata.append(
        "activity_assignment_mapping_id",
        tododata.activity_assignment_mapping_id
      );
      formdata.append("date", date);
      formdata.append("status", status);
      formdata.append("remarks", remarks);
      formdata.append("custom_fields", JSON.stringify(json));
      formdata.append("type", buttonType);
      formdata.append("file_upload_data", JSON.stringify(fileupload));
      if (isInventoryPayloadChange) {
        formdata.append("inventory_data", JSON.stringify(inventoryPayload));
      }
      if (
        tododata.todo_performance_groups[performancetab - 1]
          ?.todo_performance_group_id
      ) {
        formdata.append(
          "todo_performance_group_id",
          tododata.todo_performance_groups[performancetab - 1]
            .todo_performance_group_id
        );
      }
    }

    let basedon = [...assetentryvalue];
    if (todoperformance.length > 0) {
      basedon = [];
      assetentryvalue.forEach((ele) => {
        let perform_id = 0;
        if (tododata.activity.based_on === "Container") {
          perform_id = todoperformance.findIndex(
            (item) => item.value === ele.based_on
          );
        }
        if (perform_id !== -1)
          ele.activity_performance_id =
            todoperformance[perform_id].activity_performance_id;
        basedon.push(ele);
      });
    }
    if (process.env.REACT_APP_ENCRYPTION === "true") {
      payload["based_on"] = JSON.stringify(basedon);
    } else {
      formdata.append("based_on", JSON.stringify(basedon));
    }

    if (todoperformance.length > 0 && !performance) {
      todoperformance.forEach((ele, index) => {
        if (ele.value === assetentryvalue[0].based_on) {
          if (process.env.REACT_APP_ENCRYPTION === "true") {
            payload["activity_performance_id"] =
              todoperformance[index].activity_performance_id;
          } else {
            formdata.append(
              "activity_performance_id",
              todoperformance[index].activity_performance_id
            );
          }
        }
      });
    }
    // if (
    //   performancegroup?.activity_performances?.length === 0 &&
    //   performancegroup.todo_performance_group_id !== null &&
    //   todoperformance.length === 0 &&
    //   tododata.activity.based_on === "Document"
    // ) {
    //   if (process.env.REACT_APP_ENCRYPTION === "true") {
    //     payload["todo_performance_group_id"] =
    //       performancegroup.todo_performance_group_id;
    //   } else {
    //     formdata.append(
    //       "todo_performance_group_id",
    //       performancegroup.todo_performance_group_id
    //     );
    //   }
    // }
    // if (
    //   tododata.todo_performance_groups.length > 0 &&
    //   tododata.activity.based_on === "Container" &&
    //   !performance
    // ) {
    //   let val = false;
    //   todoperformance.forEach((ele) => {
    //     if (ele.value === assetentryvalue[0].based_on) {
    //       val = true;
    //     }
    //   });
    //   if (!val) {
    //     if (process.env.REACT_APP_ENCRYPTION === "true") {
    //       payload["todo_performance_group_id"] =
    //         performancegroup.todo_performance_group_id;
    //     } else {
    //       formdata.append(
    //         "todo_performance_group_id",
    //         performancegroup.todo_performance_group_id
    //       );
    //     }
    //   }
    // }

    if (process.env.REACT_APP_ENCRYPTION === "true") {
      // console.log('Performace ===>',{ payload });
      const keyData = encryptData(payload);
      formdata.append("key", keyData.key);
    }

    const fileUploads = [];
    for (const item of filename) {
      if (item.upload.length > 0) {
        fileUploads.push(...item.upload);
      }
    }
    if (fileUploads.length > 0) {
      for (const item of fileUploads) {
        formdata.append("file", item);
      }
    }

    return formdata;
  };

  const submitTodoPerformance = (buttontype) => {
    //console.log('submitTodoPerformance function is called complete button')
    let val = [];
    let allow = false;
    const arr = [];
    const json = [...todojson];
    todojson.forEach((ele, i) => {
      if (typeof ele.value === "string") {
        json[i].value = ele.value.trim();
      }
    });

    if (buttontype !== "Save") {
      json.forEach((ele, i) => {
        const { type, value, required, custom_field_id } = ele;
        if (
          required &&
          (value === null ||
            value === "" ||
            type === "text" ||
            type === "number")
        ) {
          arr.push(custom_field_id);
          val.push({
            value: value,
            id: custom_field_id,
            required: required,
          });
        } else if (value && type === "number") {
          arr.push(custom_field_id);
          val.push({
            value: value,
            id: custom_field_id,
            required: required,
          });
        }
      });

      todocomponentdata?.forEach((item) => {
        if (item?.todo_component) {
          const { type, min, max } = item.todo_component;
          if (type === "text" || type === "number") {
            const check = val.findIndex(
              (ele) => ele.id === item.activity_custom_field_id
            );

            if (check !== -1) {
              const value =
                type === "text" ? val[check].value?.length : val[check].value;
              if (
                (min === null || min <= value) &&
                (max === null || max >= value)
              ) {
                if (!val[check].required) {
                  arr.splice(check, 1);
                  val.splice(check, 1);
                } else if (val[check].value) {
                  arr.splice(check, 1);
                  val.splice(check, 1);
                }
              }
            }
          }
        }
      });

      // console.log('validation array ---', arr)
      setValidation(arr);
      if (val.length > 0) return;
    } else {
      json.forEach((ele, i) => {
        if (ele.value !== null && ele.value !== "" && ele.value !== "false") {
          allow = true;
        }
      });
      if (!allow && json.length > 0) {
        setShowMsg(true);
        setMessage({
          type: "info",
          title: "Field Validation",
          message: `Atleast one component should have a value to save todo performance. Please add some`,
        });
        return;
      }
    }

    let status = "";
    let checkdate = moment().isAfter(tododata.estimated_time);
    if (buttontype === "Save") {
      status = "in progress";
    } else {
      status = checkdate ? "completed with delay" : "completed";
    }
    if (
      buttontype !== "Save" &&
      tododata?.activity?.is_upload_allowed === "1"
    ) {
      for (const item of filename) {
        if (item.is_mandatory === true && item.upload.length === 0) {
          swal({
            content: (
              <CustomeModal
                type="warning"
                title="Warning!"
                content={`${item.file_name} is required mandatory upload.`}
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
          return;
        }
      }
    }

    const checkInventoryData = inventoryPayload.find(ele => (ele.actual_qty && !ele.actual_date) || (!ele.actual_qty && ele.actual_date));

    if(checkInventoryData){
      let name = "";
      if(checkInventoryData?.sku_master_id){
        const sku = performanceInventoryData.inventory.find(ele => ele.sku_master_id === checkInventoryData.sku_master_id);
        if(sku) name = sku.sku_name;
      }else{
        const product = performanceInventoryData.inventory.find(ele => ele.product_master_id === checkInventoryData.product_master_id);
        if(product) name = product.product_name;
      }

      swal({
        content: (
          <CustomeModal
            type="warning"
            title="Warning!"
            content={`Actual qty and date are required ${"for "+name}.`}
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });

      return;
    }

    setLoader(true);

    const payload = createPayload(json, status, buttontype.toLowerCase());

    dispatch(
      createTodoPerformance(payload, (res) => {
        if (res?.status) {
          dispatch(
            getAllActivities(activity_assignment_id, (resp) => {
              setLoader(false);
            })
          );

          dispatch({ type: PERFORMANCE_LOADER, payload: true });
          dispatch(
            getTodoPerformance(
              activity_assignment_id,
              tododata.activity.activity_id,
              (res) => {
                dispatch({ type: PERFORMANCE_LOADER, payload: false });
              }
            )
          );

          if (buttontype.toLowerCase() !== "save") {
            setAllowBasedon(false);
          }
          setPerformance(false);
          setFileUpload([]);
          setActiveEntry([]);

          if (tododata.activity.based_on === "Container") {
            setAssetEntryValue([{ based_on: "" }]);
          }

          const type =
            buttontype.toLowerCase() === "save" ? "saved" : "performed";
          swal({
            content: (
              <CustomeModal
                type="success"
                title="Success!"
                content={`Todo ${type} sucessfully`}
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        } else {
          setLoader(false);
          swal({
            content: (
              <CustomeModal
                type="error"
                title="Error!"
                content="Something went wrong. Please try again later."
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        }
      })
    );
  };

  const editTodoPerformance = () => {
    let val = [];
    const arr = [];
    const json = [...todojson];

    json.forEach((ele, i) => {
      const { type, value, required, custom_field_id } = ele;
      if (typeof ele.value === "string") {
        json[i].value = ele.value.trim();
      }
      if (
        required &&
        (value === null || value === "" || type === "text" || type === "number")
      ) {
        arr.push(custom_field_id);
        val.push({
          value: value,
          id: custom_field_id,
        });
      } else if (value && type === "number") {
        arr.push(custom_field_id);
        val.push({
          value: value,
          id: custom_field_id,
          required: required,
        });
      }
    });

    todocomponentdata?.forEach((item) => {
      if (item?.todo_component) {
        const { type, min, max } = item.todo_component;
        if (type === "text" || type === "number") {
          const check = val.findIndex(
            (ele) => ele.id === item.activity_custom_field_id
          );
          if (check !== -1) {
            const value =
              type === "text" ? val[check].value?.length : val[check].value;
            if ((min === null || min <= value) &&
              (max === null || max >= value)) {
              arr.splice(check, 1);
              val.splice(check, 1);
            }
          }
        }
      }
    });
    setValidation(arr);
    // console.log('val', val)
    if (val.length > 0) return;
    if (tododata?.activity?.is_upload_allowed === "1") {
      for (const item of filename) {
        if (item.is_mandatory === true && item.upload.length === 0) {
          swal({
            content: (
              <CustomeModal
                type="warning"
                title="Warning!"
                content={`${item.file_name} is required mandatory upload.`}
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
          return;
        }
      }
    }
    setLoader(true);
    // console.log('condition statisfy ----', json)
    const payload = createPayload(json, tododata.status);
    const request = {
      onSuccess: (res) => {
        if (res.status) {
          dispatch(
            getAllActivities(activity_assignment_id, (resp) => {
              setLoader(false);
            })
          );

          dispatch({ type: PERFORMANCE_LOADER, payload: true });
          dispatch(
            getTodoPerformance(
              activity_assignment_id,
              tododata.activity.activity_id,
              (res) => {
                dispatch({ type: PERFORMANCE_LOADER, payload: false });
              }
            )
          );
        }
        if (tododata.activity.based_on === "Document") {
          setAllowBasedon(false);
        }
        // setLoader(false);
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content={`Todo sucessfully updated`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
      onError: (error) => {
        setLoader(false);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(updateTodoPerformance(payload, request));
  };

  const removeTodoPerformance = () => {
    setAllowUpdate(false);
    setLoader(true);
    const request = {
      onSuccess: (res) => {
        if (res.status) {
          dispatch(
            getAllActivities(activity_assignment_id, (resp) => {
              setLoader(false);
              if (resp.status) {
                setAssetEntryValue([{ based_on: "" }]);
                setActiveEntry([]);
                setFileUpload([]);
              }
            })
          );

          dispatch(
            getTodoPerformance(
              activity_assignment_id,
              tododata.activity.activity_id,
              (res) => {
                dispatch({ type: PERFORMANCE_LOADER, payload: false });
              }
            )
          );
        }
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content={`Todo sucessfully deleted`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
      onError: (error) => {
        setLoader(false);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    let activityperformanceid;
    todoperformance.forEach((ele, index) => {
      if (ele.value === assetentryvalue[0].based_on) {
        activityperformanceid = todoperformance[index].activity_performance_id;
      }
    });
    const payload = {
      activity_performance_id: activityperformanceid,
      activity_assignment_mapping_id: tododata.activity_assignment_mapping_id,
      status: "pending",
    };
    dispatch(deleteTodoPerformance(payload, request));
  };
  const uploadFile = (e, id) => {
    setLoader(true);
    for (const item of e) {
      let fileName = "";
      var filetype = item.name.split(".").pop();
      fileName = item.name;
      const type = [
        "pdf",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "jpeg",
        "jpg",
        "png",
        "bmp",
        "txt",
      ];
      const maxFileSize = 4 * 1024 * 1024;
      let name = "";
      filename.forEach((ele) => {
        ele.upload.forEach((ele1) => {
          if (ele1.name === item.name) {
            name = item.name;
          }
        });
      });
      if (name !== "") {
        setLoader(false);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`${name} already uploaded. Duplicate file upload is not allowed`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        return;
      }
      if (item.size > maxFileSize) {
        setLoader(false);
        swal({
          content: (
            <CustomeModal
              type="warning"
              title="Warning!"
              content={`${item.name} file exceeds upload limit of 4 MB.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        return;
      }
      if (!type.includes(filetype.toLowerCase())) {
        setLoader(false);
        swal({
          content: (
            <CustomeModal
              type="warning"
              title="Warning!"
              content={`${item.name} must be among these pdf, doc, docx, xls, xlsx, jpeg, jpg, png, bmp, txt.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        return;
      }
      setFileUpload((prev) => [
        ...prev,
        {
          activity_file_upload_id: id,
          file_name: fileName,
        },
      ]);
    }
    const index = filename.findIndex(
      (item) => item.activity_file_upload_id === id
    );
    filename[index].upload.push(...e);
    dispatch({
      type: GET_ALL_FILE_NAME,
      payload: filename,
    });
    setLoader(false);
  };
  const handleNewPerformance = () => {
    const arr = [];
    const check = ["toggle", "check box"];
    todocomponentdata?.forEach((ele) => {
      arr.push({
        custom_field_id: ele.activity_custom_field_id,
        value:
          check.find((item) => item === ele.todo_component?.type) !== undefined
            ? JSON.stringify(ele.todo_component.is_check_by_default)
            : ele?.todo_component?.list_selected_value ? ele.todo_component.list_selected_value : null,
        required: ele.is_required,
        type: ele.todo_component?.type,
      });
    });
    setTodoJson(arr);
    setRemarks("");
    setPerformDate(moment());
    setShowAlert(false);
    setShowMsg(false);
  };
  const handleFileUpload = (files) => {
    let filedata = [];
    const file = tododata.activity.activity_file_uploads;
    file?.forEach((ele) => {
      const findfiles = files.filter(
        (item) => item.activity_file_upload_id === ele.activity_file_upload_id
      );
      if (findfiles.length > 0) {
        const files = [];
        findfiles.forEach((e1) => {
          files.push({ name: e1.file_name });
        });
        ele.upload = files;
      } else ele.upload = [];
      filedata.push(ele);
    });
    dispatch({
      type: GET_ALL_FILE_NAME,
      payload: filedata,
    });
  };

  const handleAssetTypes = () => {
    const assetypes = [];
    tempdata.forEach((ele1) => {
      if (ele1.type !== undefined) delete ele1.type;
      assetypes.push(ele1);
    });
    dispatch({ type: SET_ASSET_TYPES, payload: assetypes });
  };

  const handleSendReminder = () => {
    const request = {
      activity_assignment_mapping_id: tododata?.activity_assignment_mapping_id,
      onSuccess: (res) => {
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content={`Todo reminder send successfully.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
      onError: (error) => {
        setLoader(false);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(sendTodoReminder(request));
  }

  return (
    <>
      {performanceLoader ? (
        <div className="h-[90vh] flex justify-center items-center">
          <div class="px-6">
            <svg
              className="animate-spin w-12 h-12 fill-current shrink-0"
              viewBox="0 0 16 16"
            >
              <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
            </svg>
          </div>
        </div>
      ) : (
        <div
          className={`sm:pt-2 overflow-y-auto overflow-x-hidden h-screen`}
          style={{
            maxHeight: embedded ? "calc(100vh - 48px)" : "calc(100vh - 136px)",
          }}
        >
          {/* ---------- Header ------------- */}
          {activities.length > 0 &&
            userData.type !== "customer" &&
            userData.type !== "collaborator" && (
              <div className={`flex items-center justify-between`}>
                <div
                  className="flex items-center space-x-2 overflow-x-auto no-scrollbar"
                  style={{ maxWidth: "calc(100% - 293px)" }}
                >
                  {addPerformanceTab.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className={`${
                          performancetab === index + 1
                            ? "bg-[--bg-color-500]"
                            : "bg-[#F3F7FE]"
                        } h-[30px] min-w-[120px] text-center rounded flex justify-center items-center relative px-1 space-x-1`}
                        onClick={(e) => {
                          setAllowBasedon(false);
                          setPerformanceTab(index + 1);
                          setActiveEntry([]);
                          setFileUpload([]);
                          if (assetentryvalue[0].based_on !== "") {
                            setAssetEntryValue([{ based_on: "" }]);
                          }
                          if (
                            tododata.todo_performance_groups.length >=
                            index + 1
                          ) {
                            setPerformance(false);
                            const group =
                              tododata.todo_performance_groups[index];
                            dispatch({
                              type: GET_ALL_TODO_PERFORMANCE_GROUP,
                              payload: group,
                            });
                            dispatch({
                              type: GET_ALL_TODO_PERFORMANCE,
                              payload: group.todo_performances,
                            });
                            if (
                              tododata.activity.based_on === "Container" &&
                              group.todo_performances.length > 0
                            ) {
                              const assetypes = [];
                              tempdata.forEach((ele1) => {
                                const index = group.todo_performances.findIndex(
                                  (ele2) =>
                                    ele1.asset_name + "-" + ele1.asset_type ===
                                    ele2.value
                                );
                                if (index !== -1) {
                                  ele1.type =
                                    group.todo_performances[index].type;
                                  assetypes.push(ele1);
                                } else {
                                  if (ele1.type !== undefined) delete ele1.type;
                                  assetypes.push(ele1);
                                }
                              });
                              dispatch({
                                type: SET_ASSET_TYPES,
                                payload: assetypes,
                              });
                            }
                            if (group.todo_performances.length > 0) {
                              handleFileUpload(
                                group.todo_performances[0].files
                              );
                            } else handleFileUpload([]);
                          } else {
                            setPerformance(true);
                            dispatch({
                              type: GET_ALL_TODO_PERFORMANCE_GROUP,
                              payload: {
                                activity_performances: [],
                                todo_performance_group_id: null,
                                length:
                                  tododata.todo_performance_groups.length + 1,
                              },
                            });
                            dispatch({
                              type: GET_ALL_TODO_PERFORMANCE,
                              payload: [],
                            });
                            if (tododata.activity.based_on === "Container") {
                              handleAssetTypes();
                            }
                            handleFileUpload([]);
                          }
                        }}
                      >
                        <p
                          title={moment(item.date).format("DD/MMM/YYYY HH:mm")}
                          className={`${
                            performancetab === index + 1
                              ? "text-white"
                              : "text-[#535860]"
                          } text-xs font-semibold leading-3 tracking-tight max-w-3/4 truncate`}
                        >
                          {moment(item.date).format("DD/MMM/YYYY HH:mm")}
                        </p>
                        <div className="">
                          <div
                            className={`w-3 h-3 border-2 rounded-full flex ${
                              performancetab === index + 1
                                ? "border-white"
                                : "border-[--bg-color-500]"
                            } `}
                          >
                            <div
                              className={`flex-1 ${
                                item.type === "save" || item.type === "complete"
                                  ? performancetab === index + 1
                                    ? "bg-white"
                                    : "bg-[--bg-color-500]"
                                  : ""
                              }`}
                            ></div>
                            <div
                              className={`flex-1 ${
                                item.type === "complete"
                                  ? performancetab === index + 1
                                    ? "bg-white"
                                    : "bg-[--bg-color-500]"
                                  : ""
                              }`}
                            ></div>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  { !tododata?.activity?.change_inventory && (
                    <div
                      className={`text-xs min-w-[120px] leading-3 ${
                        tododata?.activity?.is_immutable
                          ? "pointer-events-none text-[--bg-color-300]"
                          : "cursor-pointer text-[--bg-color-500]"
                      }  font-semibold tracking-tight `}
                      onClick={(e) => {
                        if (
                          tododata?.todo_performance_groups.length + 1 >
                          addPerformanceTab.length
                        ) {
                          setAllowBasedon(false);
                          setAssetEntryValue([{ based_on: "" }]);
                          handleNewPerformance();
                          handleFileUpload([]);
                          setFileUpload([]);
                          setaddPerformanceTab([
                            ...addPerformanceTab,
                            { date: new Date() },
                          ]);
                          setPerformance(true);
                          setPerformanceTab(
                            tododata.todo_performance_groups.length + 1
                          );
                          dispatch({
                            type: GET_ALL_TODO_PERFORMANCE_GROUP,
                            payload: {
                              activity_performances: [],
                              todo_performance_group_id: null,
                              length: tododata.todo_performance_groups.length + 1,
                            },
                          });
                          dispatch({
                            type: GET_ALL_TODO_PERFORMANCE,
                            payload: [],
                          });
                          if (tododata.activity.based_on === "Container") {
                            handleAssetTypes();
                          }
                          setActiveEntry([]);
                        }
                      }}
                    >
                      + Add Performance
                    </div>
                  )}
                  
                </div>
                <div className={`space-x-2`}>
                  <button
                    className={`btn-sm ${
                      !getPerformActivity(
                        tododata,
                        type,
                        email,
                        user_id,
                        department_id,
                        collaborator_ids
                      ) ||
                      tododata?.status === "completed with delay" ||
                      tododata?.status === "completed" ||
                      !tododata.can_perform ||
                      !Number(tododata?.activity.is_extensible) ||
                      tododata?.activity?.is_immutable
                        ? // userinternal
                          "!bg-slate-100 !border-slate-200 pointer-events-none"
                        : "!bg-white border !border-slate-200 hover:!border-slate-300"
                    }
                text-[#1E293B] text-sm leading-5 font-medium px-5`}
                    onClick={() => setIsExtend(true)}
                  >
                    Extend
                  </button>
                  <button
                    className={`btn-sm ${
                      !getPerformActivity(
                        tododata,
                        type,
                        email,
                        user_id,
                        department_id,
                        collaborator_ids
                      ) ||
                      tododata?.status === "completed with delay" ||
                      tododata?.status === "completed" ||
                      !tododata.can_perform ||
                      tododata?.activity?.is_immutable
                        ? // userinternal
                          "!bg-slate-100 !border-slate-200 pointer-events-none"
                        : "!bg-white border !border-slate-200 hover:!border-slate-300"
                      } text-[#1E293B] text-sm leading-5 font-medium px-5`}
                    onClick={() => setIsTransfer(true)}
                  >
                    Transfer
                  </button>
                    {["completed", "completed with delay"].includes(tododata?.status) ? (
                      <button
                        className={`btn-sm ${
                          todoperformance.length === 0
                            ? "!bg-slate-100 !border-slate-200 pointer-events-none"
                            : "!bg-white border !border-slate-200 hover:!border-slate-300"
                        } text-[#1E293B] text-sm font-medium leading-5 px-5`}
                        onClick={(e) => {
                          if (todoperformance.length > 0) {
                            setOpenShareModal(true);
                          }
                        }}
                      >
                        Send as E-mail
                      </button>
                    ) : (
                      <button
                        className={`btn-sm !bg-white border !border-slate-200 hover:!border-slate-300 text-[#1E293B] text-sm font-medium leading-5 px-5`}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSendReminder();
                        }}
                      >
                        Send Reminder
                      </button>
                    )}
                </div>
              </div>
            )}
          <ExtendActivityModal
            modalOpen={isextend}
            setModalOpen={setIsExtend}
            mappingid={tododata?.activity_assignment_mapping_id}
            activity_id={tododata?.activity?.activity_id}
            activity_assignment_id={activity_assignment_id}
          />
          <TransferActivityModal
            modalOpen={istransfer}
            setModalOpen={setIsTransfer}
            mappingid={tododata?.activity_assignment_mapping_id}
            activityId={tododata?.activity?.activity_id}
            activity_assignment_id={activity_assignment_id}
            // updateTable={updatePerformanceTable}
            // setUpdateTable={setUpdatePerformanceTable}
          />
          {/* Modal for share */}
          {type !== "customer" && type !== "collaborator" && (
            <Sharemodal
              modalOpen={openShareModal}
              setModalOpen={setOpenShareModal}
              activityId={tododata?.activity?.activity_id}
              mappingid={tododata?.activity_assignment_mapping_id}
              activity_assignment_id={activity_assignment_id}
              // embedded={false}
            />
          )}

          {tododata.status === "tentative" && (
            <div className="py-2">
                <Pageinfo
                  type="info"
                  title="The Status of this To Do is Tentative"
                  message={"This to do will be activated if the dependency is triggered."}
                  open={userallow}
                  setOpen={setUserAllow}
                />
            </div>
          )}

          {(tododata?.status === "completed" ||
            tododata?.status === "completed with delay" ||
            showAlert ||
            showmsg ||
            mandatory_extension) && (
            <div className="py-2">
              {tododata?.status === "completed" ||
              tododata?.status === "completed with delay" ? (
                <div>
                  <Pageinfo
                    type="info"
                    title={getBannerMessage(
                      tododata,
                      performancetab,
                      userData.type === "customer"
                    )}
                    message={getMessage(
                      tododata,
                      performancetab,
                      userData.type === "customer"
                    )}
                    open={showAlert}
                    setOpen={setShowAlert}
                    close={false}
                  />
                </div>
              ) : null}

              {!showAlert && (
                <Pageinfo
                  type="info"
                  title="To Do not Assigned to You"
                  message={
                    type === "customer"
                      ? "As a customer you cannot perform this to do."
                      : `Only ${
                          tododata?.user === null
                            ? tododata?.department?.name
                            : tododata?.user?.name
                        } can perform this To Do.`
                  }
                  open={userallow}
                  setOpen={setUserAllow}
                />
              )}

              <Pageinfo
                type={message.type}
                title={message.title}
                message={message.message}
                open={showmsg}
                setOpen={setShowMsg}
              />
              <Pageinfo
                type="info"
                title="To Do Performance is Locked"
                message={`Please submit an extension request. Once the extension is approved the to do can be performed.`}
                open={mandatory_extension}
                setOpen={setMandatory_Extension}
                close={false}
              />
            </div>
          )}
          <Loader modalOpen={loader} setModalOpen={setLoader} />
          <div
            className={`flex space-x-2 relative h-screen ${
              !showAlert ? "mt-2" : ""
            }`}
            style={{
              maxHeight: !showAlert
                ? "calc(100vh - 193px)"
                : "calc(100vh - 252px)",
            }}
          >
            {/* ------------ Asset List Side bar ----------------- */}
            {/* {showAssets && ( */}
            {tododata?.activity?.based_on !== "Document" &&
              tempdata.length > 0 && (
                <div className="w-[20%]">
                  <AssetList
                    showAlert={showAlert}
                    assetentryvalue={assetentryvalue}
                    setAssetEntryValue={setAssetEntryValue}
                    activeentry={activeentry}
                    setActiveEntry={setActiveEntry}
                    handleNewPerformance={handleNewPerformance}
                    performance={performance}
                    handleFileUpload={handleFileUpload}
                    setFileUpload={setFileUpload}
                    setAllowUpdate={setAllowUpdate}
                    // assetentry={assetentry}
                  />
                </div>
              )}

            {/* ----------- Main Body with custome fields -------- */}
            <form
              className={`${
                tododata?.activity?.based_on !== "Document" &&
                tempdata.length !== 0 &&
                assetentryvalue[0].based_on !== ""
                  ? "w-[80%] "
                  : "w-full "
              }space-y-2`}
            >
              {(tododata?.activity?.based_on === "Container" &&
                tempdata.length > 0 &&
                assetentryvalue.filter((ele) => ele.based_on !== "").length >
                  0) ||
              tododata?.activity?.based_on === "Document" ? (
                <div className="w-full space-y-2">
                  <div className={`w-full bg-[--bg-color-50] rounded-md px-3 py-3`}>
                    <h4 className="text-sm leading-4 text-[#535860] font-bold tracking-tight">
                      To Do Details
                    </h4>
                    <SimpleBarReact style={{ maxHeight: "calc(100% - 25px)" }}>
                      <div className="overflow-x-hidden">
                        {/* Inventory Component */}
                        {performanceInventoryData &&
                          tododata.activity.change_inventory && (
                            <div className="my-3 px-3 py-6 bg-[--bg-color-50] rounded-md w-full space-y-2">
                              {performanceInventoryData.inventory.map(
                                (inventoryItem, i) => {
                                  return (
                                    <div className="grid grid-cols-4 gap-4">
                                      <div className="space-y-2">
                                        <InputField
                                          label={
                                            i === 0
                                              ? performanceInventoryData.inventory_order_type ===
                                                "purchase_order"
                                                ? "SKU"
                                                : "Product"
                                              : ""
                                          }
                                          disabled
                                          value={
                                            performanceInventoryData.inventory_order_type ===
                                            "purchase_order"
                                              ? inventoryItem.sku_name
                                              : inventoryItem.product_name
                                          }
                                        />
                                      </div>
                                      <div className="space-y-2">
                                        <InputField
                                          label={i === 0 ? "Planned Qty" : ""}
                                          disabled
                                          value={inventoryItem.planned_qty}
                                        />
                                      </div>
                                      <div className="space-y-2">
                                        <InputField
                                          placeholder="Actual Qty"
                                          label={i === 0 ? "Actual Qty" : ""}
                                          value={
                                            inventoryPayload[i]?.actual_qty
                                          }
                                          onChange={(e) => {
                                            const value = sanitizeInput(
                                              e.target.value
                                            );
                                            handleInventoryChange(
                                              value,
                                              "actual_qty",
                                              i
                                            );
                                            setIsInventoryPayloadChange(true);
                                          }}
                                          disabled={allowupdate || inventoryItem.actual_date}
                                        />
                                      </div>
                                      <div className="space-y-2">
                                        { allowupdate || inventoryItem.actual_date ? (
                                          <div className="relative">
                                            <InputField
                                              disabled
                                              label={
                                                i === 0 ? "Actual Date" : ""
                                              }
                                              type="text"
                                              placeholder="Actual Date"
                                              suffix={
                                                <span className="far fa-calendar text-[#1E293B]"></span>
                                              }
                                              value={ inventoryItem.actual_date ? moment(
                                                inventoryItem.actual_date
                                              ).format("YYYY-MM-DD HH:mm") : ""}
                                            />
                                          </div>
                                        ) : (
                                          <div className="w-full relative">
                                            <label
                                              className={`block text-sm font-medium mb-1 leading-3 tracking-tight ${
                                                i !== 0 && "hidden"
                                              }`}
                                              htmlFor="card-city"
                                            >
                                              {i === 0 ? "Actual Date" : ""}
                                            </label>
                                            <Flatpickr
                                              disabled={allowupdate}
                                              data-enable-time
                                              options={{
                                                altFormat: "j M, Y H:i",
                                                dateFormat: "Y-m-d",
                                                time_24hr: true,
                                                disableMobile: true,
                                                enableTime: true,
                                                altInput: true,
                                              }}
                                              name="actual_date"
                                              onChange={(e) => {
                                                const value = e[0]
                                                  ? new Date(e[0]).toISOString()
                                                  : e[0];

                                                handleInventoryChange(
                                                  value,
                                                  "actual_date",
                                                  i
                                                );
                                                setIsInventoryPayloadChange(
                                                  true
                                                );
                                              }}
                                              value={
                                                inventoryPayload[i]?.actual_date
                                              }
                                              render={(
                                                { defaultValue },
                                                ref
                                              ) => {
                                                return (
                                                  <div className="w-full">
                                                    <input
                                                      title="Component Placeholder"
                                                      className="form-input w-[100%] truncate disabled:border-slate-200"
                                                      defaultValue={
                                                        defaultValue
                                                      }
                                                      ref={ref}
                                                      placeholder="Actual Date"
                                                    />
                                                    <div
                                                      className={`absolute inset-0 left-auto ${
                                                        i === 0
                                                          ? "!top-8"
                                                          : "!top-1"
                                                      } opacity-100 group`}
                                                    >
                                                      <span className="text-sm text-slate-500 font-medium px-3 ">
                                                        <span className="far fa-calendar text-[#1E293B] z-60 bg-white"></span>
                                                      </span>
                                                    </div>
                                                  </div>
                                                );
                                              }}
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          )}

                        {/* To Do Custom Fields */}
                        <div className="">
                          {tododata?.activity?.based_on === "Document" &&
                            tododata?.activity?.label && (
                              <InputField
                                type="text"
                                label={tododata.activity.label}
                                placeholder={`Enter ${tododata.activity.label}`}
                                required
                                value={
                                  assetentryvalue.length > 0
                                    ? assetentryvalue[0].based_on
                                    : ""
                                }
                                wrapperClass="p-1 w-1/2"
                                onChange={(e) => {
                                  setAllowBasedon(true);
                                  const value = sanitizeInput(e.target.value);

                                  setAssetEntryValue([{ based_on: value }]);
                                }}
                                disabled={allowupdate}
                              />
                            )}

                          {customFieldMaxRowSize?.toString() &&
                            todocomponentdata?.length > 0 && (
                              <div>
                                {todocomponentdata?.map(
                                  (customeComponent, index) => {
                                    const filteredComponentList =
                                      todocomponentdata?.filter(
                                        (element) =>
                                          JSON.parse(element.grid_position)
                                            .y === index
                                      );

                                    if (index <= customFieldMaxRowSize) {
                                      return (
                                        <div className="flex flex-wrap">
                                          {filteredComponentList.map(
                                            (comp, indexNumber) => {
                                              return renderInput(
                                                comp,
                                                indexNumber,
                                                validation
                                              );
                                            }
                                          )}
                                        </div>
                                      );
                                    }
                                  }
                                )}
                              </div>
                            )}
                        </div>
                      </div>
                    </SimpleBarReact>
                  </div>
                  <div className="w-full h-[30%] grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-2">
                    <div className="bg-[--bg-color-50] rounded-md px-6 py-3">
                      <h4 className="text-sm font-bold leading-4 tracking-tight text-[#535860]">
                        Performance Details
                      </h4>
                      <div className="space-y-2">
                        {allowupdate ? (
                          <PerformanceDateTime
                            allowupdate={allowupdate}
                            performdate={performdate}
                          />
                        ) : (
                          <Flatpickr
                            data-enable-time
                            options={{
                              enableTime: true,
                              altInput: true,
                              altFormat: "j M, Y H:i",
                              dateFormat: "Y-m-d H:i",
                              time_24hr: true,
                              defaultDate: moment().format("YYYY-MM-DD HH:mm"),
                              maxDate: new Date(),
                            }}
                            id="datepickr"
                            placeholder="Enter Performance Date/Time"
                            className={`form-input w-full`}
                            onChange={(e) => {
                              setPerformDate(
                                moment(e[0])
                                  // .utc()
                                  // .local()
                                  // .format("YYYY-MM-DD HH:mm")
                              );
                            }}
                          />
                        )}
                        <textarea
                          className={`form-textarea w-full mb-2 resize-none ${
                            allowupdate &&
                            "!bg-slate-100 !text-slate-400 cursor-not-allowed"
                          }`}
                          rows={2}
                          name="remarks"
                          placeholder="Enter Remarks"
                          value={remarks}
                          onChange={(e) => {
                            const value = sanitizeInput(e.target.value);
                            setRemarks(value);
                          }}
                          disabled={allowupdate}
                        />
                      </div>
                    </div>
                    {tododata?.activity?.is_upload_allowed === "1" ? (
                      <div className="w-full sm:w-full mx-1 px-6 p-3 bg-[--bg-color-50] rounded-md">
                        <div>
                          <h4 className="text-sm font-bold leading-4 tracking-tight text-[#535860] mb-3">
                            Document Upload
                          </h4>
                          {filename.length > 0 && (
                            <div className={`space-y-2`}>
                              {filename?.map((item, i) => {
                                return (
                                  <div className={`${allowupdate ? "bg-slate-100" : "bg-white"} rounded-md border border-[#E8E8E8] flex justify-between items-center py-2 px-3`}>
                                    <div className="w-full">
                                      <div className="flex flex-row items-center justify-between">
                                        <div className="font-inter font-bold text-[13px] text-[#535860]">
                                          {item.file_name} {item.is_mandatory && (
                                            <span>
                                              <span className="text-rose-500 ml-1">
                                                *
                                              </span>
                                            </span>
                                          )}
                                        </div>
                                        {/* {item.upload.length === 0 && (                                       
                                          <div
                                            type="button"
                                            onClick={(e) => {
                                              if (
                                                getPerformActivity(
                                                  tododata,
                                                  type,
                                                  email,
                                                  user_id,
                                                  department_id
                                                ) &&
                                                !allowupdate
                                              ) {
                                                document
                                                  .getElementById(
                                                    item.activity_file_upload_id
                                                  )
                                                  .click();
                                              }
                                            }}
                                          >
                                            <p
                                              className={`text-xs leading-3 font-semibold tracking-tight text-[--bg-color-500] 
                                              ${
                                                getPerformActivity(
                                                  tododata,
                                                  type,
                                                  email,
                                                  user_id,
                                                  department_id
                                                ) && !allowupdate
                                                  ? "cursor-pointer"
                                                  : "cursor-not-allowed"
                                              }`}
                                            >
                                              Select
                                            </p>
                                          </div>
                                        )} */}
                                      </div>
                                      <div className="flex flex-row items-center justify-between">
                                        <div className="text-sm w-full">
                                          {item.upload.length > 0 ? (
                                            <div className="font-semibold">
                                              {item.upload.map((ele) => {
                                                let name = ele?.name;
                                                const len =
                                                  name?.lastIndexOf(".");
                                                if (len > 25) {
                                                  var exten = name?.substr(
                                                    name?.lastIndexOf(".") - 1
                                                  );
                                                  var char = name?.substr(
                                                    0,
                                                    25
                                                  );
                                                  name = char + ".." + exten;
                                                }

                                                let found = false;
                                                todoperformance.forEach(
                                                  (ele1) => {
                                                    ele1.files.forEach(
                                                      (ele2) => {
                                                        if (
                                                          ele2.file_name ===
                                                          ele.name
                                                        ) {
                                                          found = true;
                                                        }
                                                      }
                                                    );
                                                  }
                                                );
                                                return (
                                                  <>
                                                    <div
                                                      className="py-0.5 bg-white rounded-md flex items-center justify-between"
                                                      type="button"
                                                    >
                                                      <p className="font-inter font-medium text-[13px] text-[#535860]">
                                                        {name}
                                                      </p>
                                                      <div className="flex flex-row items-center space-x-3">
                                                        { found && (
                                                          <p
                                                            name={name}
                                                            className={`fa-solid fa-arrow-down-to-line text-lg text-[--bg-color-500] ${
                                                              getPerformActivity(
                                                                tododata,
                                                                type,
                                                                email,
                                                                user_id,
                                                                department_id,
                                                                collaborator_ids
                                                              )
                                                                ? "cursor-pointer"
                                                                : "cursor-not-allowed"
                                                            }`}
                                                            onClick={(e) => {
                                                              e.stopPropagation();
                                                              todoperformance.forEach(
                                                                (ele1) => {
                                                                  ele1.files.forEach(
                                                                    (ele2) => {
                                                                      if (
                                                                        ele2.file_name ===
                                                                        ele.name
                                                                      ) {

                                                                        const request = {
                                                                          document_id: ele2.activity_performance_file_upload_id,
                                                                          onSuccess: (data) => {
                                                                            const url = decryptData(data)
                                                                            window.open(url, "_blank")
                                                                          },
                                                                          onError: (error) => {
                                                                            console.log("error occur in downloading ---", error);
                                                                          },
                                                                        };
                                                                        dispatch(getPerformanceSignedUrl(request));
                                                                      }
                                                                    }
                                                                  );
                                                                }
                                                              );
                                                            }}
                                                          >
                                                          </p>
                                                        )}
                                                        <p
                                                          name={name}
                                                          className={`fa-regular fa-trash-can text-lg text-rose-500 ${
                                                            getPerformActivity(
                                                              tododata,
                                                              type,
                                                              email,
                                                              user_id,
                                                              department_id,
                                                              collaborator_ids
                                                            ) && !allowupdate
                                                              ? "cursor-pointer"
                                                              : "cursor-not-allowed"
                                                          }`}
                                                          onClick={(e) => {
                                                            if (
                                                              getPerformActivity(
                                                                tododata,
                                                                type,
                                                                email,
                                                                user_id,
                                                                department_id,
                                                                collaborator_ids
                                                              ) &&
                                                              !allowupdate
                                                            ) {
                                                              const request = {
                                                                onSuccess: (
                                                                  res
                                                                ) => {
                                                                  if (res.status) {
                                                                    setLoader(
                                                                      false
                                                                    );
                                                                    swal({
                                                                      content: (
                                                                        <CustomeModal
                                                                          type="success"
                                                                          title="Success!"
                                                                          content={`Uploaded file sucessfully deleted`}
                                                                        />
                                                                      ),
                                                                      buttons: false,
                                                                      closeOnClickOutside: false,
                                                                      closeOnEsc: false,
                                                                    });
                                                                  }
                                                                  setLoader(false);
                                                                },
                                                              };
                                                              if (
                                                                todoperformance.length >
                                                                0
                                                              ) {
                                                                todoperformance.forEach(
                                                                  (ele1) => {
                                                                    ele1.files.forEach(
                                                                      (ele2) => {
                                                                        if (
                                                                          ele2.file_name ===
                                                                          ele.name
                                                                        ) {
                                                                          setLoader(
                                                                            true
                                                                          );
                                                                          dispatch(
                                                                            deleteUploadedFile(
                                                                              ele2.activity_performance_file_upload_id,
                                                                              request
                                                                            )
                                                                          );
                                                                        }
                                                                      }
                                                                    );
                                                                  }
                                                                );
                                                              }
                                                              filename[
                                                                i
                                                              ].upload.forEach(
                                                                (elem, index) => {
                                                                  if (
                                                                    elem.name ===
                                                                    ele.name
                                                                  ) {
                                                                    filename[
                                                                      i
                                                                    ].upload.splice(
                                                                      index,
                                                                      1
                                                                    );
                                                                  }
                                                                }
                                                              );
                                                              dispatch({
                                                                type: GET_ALL_FILE_NAME,
                                                                payload: filename,
                                                              });
                                                              setFileUpload(
                                                                fileupload.filter(
                                                                  (elen) =>
                                                                    elen.file_name !==
                                                                    ele.name
                                                                )
                                                              );
                                                            }
                                                          }}
                                                        >
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </>
                                                );
                                              })}
                                            </div>
                                          ) : (
                                            <div>
                                              {item.is_mandatory ? (
                                                <div className="font-inter font-medium italic text-rose-500 text-[13px]">
                                                  Upload pending
                                                </div>
                                              ) : (
                                                <div className="font-inter font-medium italic text-[#535860] text-[13px]">
                                                  Upload optional
                                                </div>
                                              )}
                                            </div>
                                            // <div
                                            //   className="h-[35px] bg-white rounded-md flex items-center justify-between"
                                            //   type="button"
                                            //   onClick={(e) => {
                                            //     if (
                                            //       getPerformActivity(
                                            //         tododata,
                                            //         type,
                                            //         email,
                                            //         user_id,
                                            //         department_id
                                            //       ) &&
                                            //       !allowupdate
                                            //     ) {
                                            //       document
                                            //         .getElementById(
                                            //           item.activity_file_upload_id
                                            //         )
                                            //         .click();
                                            //     }
                                            //   }}
                                            // >
                                            //   {item.upload.length === 0 &&
                                            //     (item.is_mandatory ? (
                                            //       <span>
                                            //         {item.file_name}
                                            //         <span className="text-rose-500 ml-1">
                                            //           *
                                            //         </span>
                                            //       </span>
                                            //     ) : (
                                            //       item.file_name
                                            //     ))}
                                            //   <p
                                            //     className={`text-xs leading-3 font-semibold tracking-tight text-[--bg-color-500] 
                                            // ${
                                            //   getPerformActivity(
                                            //     tododata,
                                            //     type,
                                            //     email,
                                            //     user_id,
                                            //     department_id
                                            //   ) && !allowupdate
                                            //     ? "cursor-pointer"
                                            //     : "cursor-not-allowed"
                                            // }`}
                                            //   >
                                            //     Select
                                            //   </p>
                                            // </div>
                                          )
                                          }
                                        </div>
                                        <input
                                          id={item.activity_file_upload_id}
                                          type="file"
                                          onChange={(e) => {
                                            uploadFile(
                                              e.target.files,
                                              item.activity_file_upload_id
                                            );
                                          }}
                                          hidden
                                          multiple
                                        />
                                      </div>
                                    </div>
                                    {item.upload.length === 0 && (                                       
                                          <div
                                            type="button"
                                            onClick={(e) => {
                                              if (
                                                getPerformActivity(
                                                  tododata,
                                                  type,
                                                  email,
                                                  user_id,
                                                  department_id,
                                                  collaborator_ids
                                                ) &&
                                                !allowupdate
                                              ) {
                                                document
                                                  .getElementById(
                                                    item.activity_file_upload_id
                                                  )
                                                  .click();
                                              }
                                            }}
                                          >
                                            <p
                                              className={`text-xs leading-3 font-semibold tracking-tight text-[--bg-color-500] 
                                              ${
                                                getPerformActivity(
                                                  tododata,
                                                  type,
                                                  email,
                                                  user_id,
                                                  department_id,
                                                  collaborator_ids
                                                ) && !allowupdate
                                                  ? "cursor-pointer"
                                                  : "cursor-not-allowed"
                                              }`}
                                            >
                                              Select
                                            </p>
                                          </div>
                                        )}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="w-full sm:w-full mx-1 px-6 p-3 bg-[--bg-color-50] rounded-md">
                        <h4 className="text-sm font-bold leading-4 tracking-tight text-[#535860]">
                          Document Upload
                        </h4>
                        <p className="text-xs italic py-1">
                          Document upload is disabled for this to do.
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="bg-[--bg-color-50] rounded-md px-6 py-3 space-y-2">
                    <div
                      className={`
                flex justify-between items-center py-[3px]`}
                    >
                      {/* <a className="text-xs leading-3 text-[--bg-color-500] font-semibold tracking-tight cursor-pointer">
                        View Log
                      </a> */}
                      { !tododata?.activity?.change_inventory && todoperformance.length !== 0 &&
                        todoperformance.filter((ele) => {
                          if (tododata?.activity?.based_on === "Container") {
                            return (
                              ele.value === assetentryvalue[0].based_on &&
                              ele.type !== "save"
                            );
                          }
                          return ele.type !== "save";
                        }).length !== 0 &&
                        type !== "customer" &&
                        type !== "collaborator" &&
                        !performance && (
                          <button
                            className={`btn ${
                              getPerformActivity(
                                tododata,
                                type,
                                email,
                                user_id,
                                department_id,
                                collaborator_ids
                              ) &&
                              tododata?.activity?.allow_user_edit &&
                              tododata.can_perform
                                ? "bg-rose-500 hover:bg-rose-600"
                                : "bg-rose-300 cursor-not-allowed"
                            } text-sm leading-5 text-white px-4 ml-4`}
                            onClick={(e) => {
                              e.preventDefault();
                              const status = getPerformActivity(
                                tododata,
                                type,
                                email,
                                user_id,
                                department_id,
                                collaborator_ids
                              );
                              if (
                                tododata?.activity?.allow_user_edit &&
                                status &&
                                tododata.can_perform
                              ) {
                                if (status) {
                                  swal({
                                    content: (
                                      <CustomeModal
                                        type="delete"
                                        title="Are you sure?"
                                        content="All of your data will be permanently removed from our servers forever. This action cannot be undone."
                                        onDelete={() => removeTodoPerformance()}
                                      />
                                    ),
                                    buttons: false,
                                    closeOnClickOutside: false,
                                    closeOnEsc: false,
                                  });
                                }
                              }
                            }}
                          >
                            Delete
                          </button>
                        )}

                      {todoperformance.length === 0 ||
                      performance ||
                      todoperformance.filter((ele) => {
                        if (tododata?.activity?.based_on === "Container") {
                          return (
                            ele.value === assetentryvalue[0].based_on &&
                            ele.type !== "save"
                          );
                        }
                        return ele.type !== "save";
                      }).length === 0 ? (
                        <div className="space-x-2 grow flex justify-end items-center">
                          {type !== "customer" && type !== "collaborator" && (
                            <button
                              className={`btn ${
                                getPerformActivity(
                                  tododata,
                                  type,
                                  email,
                                  user_id,
                                  department_id,
                                  collaborator_ids
                                ) &&
                                tododata.can_perform &&
                                !mandatory_extension
                                  ? "border-slate-200 hover:border-slate-300"
                                  : "text-slate-300 cursor-not-allowed"
                              } text-[#1E293B] text-sm leading-5 border px-4 ${
                                type === "customer" && type === "collaborator"
                                  ? "hidden"
                                  : ""
                              }`}
                              // type="submit"
                              onClick={(e) => {
                                e.preventDefault();
                                const status = getPerformActivity(
                                  tododata,
                                  type,
                                  email,
                                  user_id,
                                  department_id,
                                  collaborator_ids
                                );
                                if (
                                  status &&
                                  tododata.can_perform &&
                                  !mandatory_extension
                                ) {
                                  if (
                                    tododata?.activity?.based_on ===
                                      "Document" ||
                                    assetentryvalue.filter(
                                      (ele) => ele.based_on
                                    ).length > 0
                                  ) {
                                    // setSubmitTodoType("Save");
                                    submitTodoPerformance(e.target.innerText);
                                  } else {
                                    setShowMsg(true);
                                    setMessage({
                                      type: "info",
                                      title: "Field Validation",
                                      message: `${
                                        tododata?.activity?.based_on ===
                                        "Container"
                                          ? "Container"
                                          : tododata?.activity?.label
                                      } is required and it cannot be empty. Please add some`,
                                    });
                                  }
                                }
                              }}
                            >
                              Save
                            </button>
                          )}
                          <button
                            className={`btn ${
                              getPerformActivity(
                                tododata,
                                type,
                                email,
                                user_id,
                                department_id,
                                collaborator_ids
                              ) &&
                              tododata.can_perform &&
                              !mandatory_extension
                                ? "bg-[--bg-color-500] hover:bg-[--bg-color-700]"
                                : "bg-[--bg-color-300] cursor-not-allowed pointer-events-none"
                            }  text-white text-sm leading-5 font-medium px-4`}
                            onClick={(e) => {
                              e.preventDefault();
                              // console.log("tododata --", tododata);
                              {
                                e.stopPropagation();
                                const status = getPerformActivity(
                                  tododata,
                                  type,
                                  email,
                                  user_id,
                                  department_id,
                                  collaborator_ids
                                );
                                if (
                                  status &&
                                  tododata.can_perform &&
                                  !mandatory_extension
                                ) {
                                  if (
                                    tododata?.activity?.based_on ===
                                      "Document" ||
                                    assetentryvalue.filter(
                                      (ele) => ele.based_on !== ""
                                    ).length > 0
                                  ) {
                                    submitTodoPerformance(e.target.innerText);
                                  } else {
                                    setShowMsg(true);
                                    setMessage({
                                      type: "info",
                                      title: "Field Validation",
                                      message: `${
                                        tododata?.activity?.based_on ===
                                        "Container"
                                          ? "Container"
                                          : tododata?.activity?.label
                                      } is required and it cannot be empty. Please add some`,
                                    });
                                  }
                                }
                              }
                            }}
                          >
                            Complete
                          </button>
                        </div>
                      ) : (
                        <div className="space-x-2 grow flex justify-end items-center">

                         {/* This is a edit button */}

                          { allowupdate && !tododata?.activity?.change_inventory && (

                            <button
                              className={`btn ${
                                getPerformActivity(
                                  tododata,
                                  type,
                                  email,
                                  user_id,
                                  department_id,
                                  collaborator_ids
                                ) && tododata?.activity?.allow_user_edit
                                  ? "border-slate-200 hover:border-slate-300"
                                  : "text-slate-300 cursor-not-allowed pointer-events-none"
                              } ${
                                type === "customer" || type === "collaborator"
                                  ? "hidden"
                                  : ""
                              } text-[#1E293B] text-sm leading-5 border px-4`}
                              onClick={(e) => {
                                e.preventDefault();
                                const status = getPerformActivity(
                                  tododata,
                                  type,
                                  email,
                                  user_id,
                                  department_id,
                                  collaborator_ids
                                );
                                if (
                                  tododata?.activity?.allow_user_edit &&
                                  status &&
                                  tododata.can_perform
                                ) {
                                  setAllowUpdate(false);
                                  setPerformDate(
                                    moment().format("YYYY-MM-DD HH:mm")
                                  );
                                }
                              }}
                            >
                              Edit
                            </button>
                          )}

                          {/* Edit button end */}

                          {/* <span
                            className={`fa-light fa-pen text-base ${
                              getPerformActivity(
                                tododata,
                                type,
                                email,
                                user_id,
                                department_id
                              ) &&
                              tododata?.activity?.allow_user_edit &&
                              tododata.can_perform
                                ? "cursor-pointer"
                                : "cursor-not-allowed"
                            } ${
                              type === "customer" || type === "collaborator"
                                ? "hidden"
                                : ""
                            }  mr-5`}
                            style={{ color: "#9297a2" }}
                            onClick={(e) => {
                              e.preventDefault();
                              const status = getPerformActivity(
                                tododata,
                                type,
                                email,
                                user_id,
                                department_id
                              );
                              if (
                                tododata?.activity?.allow_user_edit &&
                                status &&
                                tododata.can_perform
                              ) {
                                setAllowUpdate(false);
                                setPerformDate(
                                  moment().format("YYYY-MM-DD HH:mm")
                                );
                              }
                            }}
                          ></span> */}

                          { !allowupdate && (
                            <>
                              <button
                                className={`btn ${
                                  getPerformActivity(
                                    tododata,
                                    type,
                                    email,
                                    user_id,
                                    department_id,
                                    collaborator_ids
                                  ) && tododata?.activity?.allow_user_edit
                                    ? "border-slate-200 hover:border-slate-300"
                                    : "text-slate-300 cursor-not-allowed pointer-events-none"
                                } ${
                                  type === "customer" || type === "collaborator"
                                    ? "hidden"
                                    : ""
                                } text-[#1E293B] text-sm leading-5 border px-4`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  todoperformance.forEach((ele) => {
                                    if (ele.value === assetentryvalue[0].based_on) {
                                      setPerformDate(ele.date);
                                    }
                                  });
                                  setAllowUpdate(true);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                className={`btn ${
                                  getPerformActivity(
                                    tododata,
                                    type,
                                    email,
                                    user_id,
                                    department_id,
                                    collaborator_ids
                                  ) &&
                                  tododata?.activity?.allow_user_edit &&
                                  tododata.can_perform &&
                                  type !== "collaborator" &&
                                  type !== "customer"
? "bg-[--bg-color-500] hover:bg-[--bg-color-700]"
                                : "bg-[--bg-color-300] cursor-not-allowed pointer-events-none"
                                } text-white text-sm leading-5 font-medium px-4 `}
                                onClick={(e) => {
                                  e.preventDefault();
                                  const status = getPerformActivity(
                                    tododata,
                                    type,
                                    email,
                                    user_id,
                                    department_id,
                                    collaborator_ids
                                  );
                                  if (
                                    status &&
                                    tododata.can_perform &&
                                    !allowupdate
                                  )
                                    editTodoPerformance();
                                }}
                              >
                                Update
                              </button>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : tempdata.length === 0 &&
                assetentryvalue[0].based_on === "" ? (
                <div className="h-full space-y-2">
                  <div className="bg-[--bg-color-50] p-4 rounded-md space-y-1">
                    <h4 className="text-center text-sm font-medium leading-5 tracking-normal">
                      Asset Entry is pending. Click below to do the Asset Entry.
                    </h4>
                    <h4
                      className="text-center text-[--bg-color-500] font-semibold text-sm cursor-pointer"
                      onClick={() => setTab(6)}
                    >
                      Asset Entry
                    </h4>
                  </div>
                  <div
                    className="h-full rounded-md bg-[--bg-color-50] flex justify-center items-center"
                    style={{ maxHeight: "calc(100% - 80px)" }}
                  >
                    <div
                      className="w-2/3 h-[90%] bg-[--bg-color-50] bg-center bg-opacity-25 flex justify-center items-center"
                      style={{
                        backgroundImage:
                          "linear-gradient(rgba(250, 252, 255, 0.9), rgba(250, 252, 255, 0.9)), url(" +
                          Image +
                          ")",
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      <div className="text-center">
                        <h4 className="text-[15px] leading-7 tracking-tight font-bold text-[#1E293B] ">
                          Select an Asset
                        </h4>
                        <p className="text-[15px] leading-7 tracking-tight text-[#1E293B]">
                          or Add Assets First if no Assets are Entered
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <h1 className="w-full text-center text-[--bg-color-500]">
                  Please select any asset in order to view components.
                </h1>
              )}
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default ToDoPerformTab;
